<template>
  <Layout>
    <div class="row">
      <div class="col-lg-12">
        <div class="card">
          <div class="card-body">
            <div class="card-body-form">
              <div v-if="allModify" class="page-transparent-bg"></div>

              <div class="row">
                <div class="col-md-7">
                  <div class="mb-3">
                    <label>账号</label>
                    <input
                      v-model="item.name"
                      type="text"
                      class="form-control"
                      maxlength="16"
                      placeholder="请输入账号，长度限制2-16个字符"
                    />
                  </div>
                </div>
              </div>

              <div class="row">
                <div class="col-md-7">
                  <div class="mb-3">
                    <label>姓名</label>
                    <input
                      v-model="item.realName"
                      type="text"
                      class="form-control"
                      placeholder="请输入姓名"
                    />
                  </div>
                </div>
              </div>

              <div class="row">
                <div class="col-md-7">
                  <div class="mb-3">
                    <label>邮箱</label>
                    <input
                      v-model="item.email"
                      type="text"
                      class="form-control"
                      placeholder="请输入邮箱"
                    />
                  </div>
                </div>
              </div>

              <div class="row">
                <div class="col-md-7">
                  <div class="mb-3">
                    <label>手机</label>
                    <input
                      v-model="item.phone"
                      type="text"
                      class="form-control"
                      placeholder="请输入手机"
                    />
                  </div>
                </div>
              </div>

              <div class="row">
                <div class="col-md-7">
                  <div class="mb-3">
                    <label>密码</label>
                    <input
                      v-model="item.password"
                      type="password"
                      class="form-control"
                      placeholder="请输入密码"
                    />
                  </div>
                </div>
              </div>

              <div class="row">
                <div class="col-md-7">
                  <div class="mb-3">
                    <label>确认密码</label>
                    <input
                      v-model="item.repeatPassword"
                      type="password"
                      class="form-control"
                      placeholder="请确认密码"
                    />
                  </div>
                </div>
              </div>

              <div class="row">
                <div class="col-md-7">
                  <div class="mb-3 list-header">
                    <label>所属角色</label>
                    <div class="app-select fix-header-item">
                      <!-- 多选添加 multiple 属性 -->
                      <el-select
                        v-model="item.roleId"
                        filterable
                        placeholder="请选择"
                        clearable
                      >
                        <el-option
                          v-for="item in roles"
                          :key="item.id"
                          :label="item.name"
                          :value="item.id"
                        >
                        </el-option>
                      </el-select>
                    </div>
                    <!-- <b-form-select
                      v-model="item.roleId"
                      class="form-select"
                      :options="roles"
                      type="text"
                    ></b-form-select> -->
                  </div>
                </div>
              </div>

              <div class="row">
                <div class="col-md-7">
                  <div class="mb-3">
                    <label>启用状态</label>
                    <div>
                      <el-radio v-model="item.state" label="1">启用</el-radio>
                      <el-radio v-model="item.state" label="0">禁用</el-radio>
                    </div>
                  </div>
                </div>
              </div>

              <div class="row">
                <div class="col-md-7">
                  <div class="mb-3">
                    <label>账号备注</label>
                    <div>
                      <b-form-textarea
                        v-model="item.remark"
                        rows="5"
                        placeholder="请输入账号备注"
                      ></b-form-textarea>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div
              class="row submit-bar"
              style="
        display: flex;
        align-items: center;
        height: 45px;
        padding-left: 1.25rem;
        padding-bottom: 0;
        padding-top: 0;
        margin-bottom: 0;
      "
            >
              <div class="col-md-12">
                <!-- <div class="last-time pull-left">由 用户名 编辑于 2021-09-12 12:11:22</div> -->
                <div class="bar-handle">
                  <button
                    class="btn-sm btn btn-outline-dark"
                    type="button"
                    @click="goBack()"
                  >
                    取消
                  </button>
                  <button
                    @click="submitPreserve()"
                    class="btn-sm btn btn-primary"
                    type="button"
                  >
                    {{ index_id ? "保存" : "创建" }}
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </Layout>
</template>

<script>
import Vue from "vue";
import Layout from "@/router/layouts/main";
import account from "@/server/api/account";
import media from "@/server/api/media";

import roles from "@/server/api/roles";

export default {
  components: {
    Layout,
  },
  data() {
    return {
      item: {
        state: "1",
        roleId: "",
      },
      index_id: "",
      allModify: false,
      roles: [],
    };
  },

  mounted() {
    this.getRoles();
    // 获取详情
    if (this.$route.query.id) {
      this.index_id = this.$route.query.id;
      this.fetch();
    }
    if (this.$route.query.allModify) {
      this.allModify = true;
    }
  },

  methods: {
    getRoles() {
      let params = {
        page: 1,
        pageSize: 999,
        type: 2,
        mediaId: JSON.parse(localStorage.chosedMedia).id,
      };
      roles.list(params).then((resp) => {
        if (resp.code == 0) {
          if (resp.data.items) {
            this.roles = resp.data.items;
            this.roles.unshift({ name: "", id: "" });
          }
        } else {
          if (this.$refs.loading) {
            this.$refs.loading.hide();
          }
        }
      });
    },

    submitPreserve() {
      let params = JSON.parse(JSON.stringify(this.item));
      if (params.name) {
        if (params.name.length < 2) {
          Vue.swal("账号最少输入2个字符");
          return;
        }
      } else {
        Vue.swal("请输入账号");
        return;
      }

      if (params.repeatPassword) {
        if (params.password == params.repeatPassword) {
        } else {
          Vue.swal("两次输入密码不一致");
          return;
        }
      } else {
        Vue.swal("请确认密码");
        return;
      }
      // params.password = params.password;

      if (params.roleId) {
        this.roles.forEach(function(data) {
          if (data.id == params.roleId) {
            params.mediaVOS = [
              {
                id: JSON.parse(localStorage.chosedMedia).id,
                roleName: data.name,
                roleId: data.id,
              },
            ];
            // params.roleName = data.name;
            // params.roleId = data.id;
          }
        });
      } else {
        params.mediaVOS = [
          {
            id: JSON.parse(localStorage.chosedMedia).id,
            roleId: 0,
          },
        ];
        //没有角色id的时候传0清空之前的角色
        // params.roleId = 0;
        // Vue.swal("请选择所属角色");
        // return;
      }
      // params.id = JSON.parse(localStorage.chosedMedia).id;
      delete params.roleId;

      console.log(params);
      media.insertOperate(params).then((resp) => {
        if (resp.code == 0) {
          this.addCache("operator-edit", {
            changed: true,
          });
          let text = this.index_id ? "编辑成功！" : "创建成功";
          Vue.swal({
            icon: "success",
            title: text,
            showConfirmButton: false,
            timer: 1000,
          });
          this.goBack();
        } else {
          Vue.swal({
            icon: "error",
            title: resp.msg,
            showConfirmButton: false,
            timer: 1500,
          });
        }
      });

      // if(this.index_id){
      //   account.modify(params).then(resp => {
      //     if (resp.code == 0) {
      //       Vue.swal({
      //         icon: "success",
      //         title: "修改成功！",
      //         showConfirmButton: false,
      //         timer: 1000
      //       });
      //       this.goBack()
      //     } else {
      //       Vue.swal({
      //         icon: "error",
      //         title: resp.msg,
      //         showConfirmButton: false,
      //         timer: 1500,
      //       });
      //     }
      //   })
      // } else {
      //   account.create(params).then(resp => {
      //     if (resp.code == 0) {
      //       Vue.swal({
      //         icon: "success",
      //         title: "添加成功！",
      //         showConfirmButton: false,
      //         timer: 1000
      //       });
      //       this.goBack()
      //     } else {
      //       Vue.swal({
      //         icon: "error",
      //         title: resp.msg,
      //         showConfirmButton: false,
      //         timer: 1500,
      //       });
      //     }
      //   })
      // }
    },

    goBack() {
      this.$router.go(-1);
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped></style>
